import React, { useEffect, useState } from 'react';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Link } from 'gatsby';
import { WebsiteImage } from 'components/TitleDescription';
import SubNavNavigation from './components/SubNavNavigation/SubNavNavigation';
import { SubNavContainer, SubNavInnerContainer, SubNavMobileNav } from './styles';

const SubNav = ({
  data,
  simpleHeader,
  mainHeader,
  transparent,
  isScrolled,
  text,
  ...otherProps
}) => {
  const [isMobileNavOpen, toggleIsMobileNavOpen] = useState(false);

  useEffect(() => {
    if (isMobileNavOpen) {
      document.body.style.overflowY = 'hidden';
      document.body.style.height = '100%';
    } else {
      document.body.style.overflowY = null;
      document.body.style.height = null;
    }

    return () => {
      document.body.style.overflowY = null;
      document.body.style.height = null;
    };
  }, [isMobileNavOpen]);

  const navigation = <SubNavNavigation data={data} toggleIsMobileNavOpen={toggleIsMobileNavOpen} />;
  const transparentUntilScrolled = !isScrolled && transparent;

  return (
    <SubNavContainer data-testid="subnav" className="subnav" transparent={transparentUntilScrolled}>
      <SubNavInnerContainer className="subnav--inner-container">
        <div className="subnav--left">
          {data?.logo && (
            <Link to={data?.logo.slug}>
              <WebsiteImage className="subnav--logo" src={data?.logo.src} alt={data?.logo.alt} />
            </Link>
          )}
          {navigation}
        </div>
        <div className="subnav--right">
          {data?.cta}
          <div className="sub-nav--arrow" onClick={() => toggleIsMobileNavOpen(!isMobileNavOpen)}>
            {isMobileNavOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
          </div>
        </div>
        <SubNavMobileNav
          simpleHeader={simpleHeader}
          mainHeader={mainHeader}
          isOpen={isMobileNavOpen}
          className="subnav-mobile"
        >
          {navigation}
        </SubNavMobileNav>
      </SubNavInnerContainer>
    </SubNavContainer>
  );
};

export default SubNav;
